{
  "previous": "Trước",
  "next": "Tiếp theo",
  "complete": "Hoàn tất",
  "verifyAndCheckIn": "Xác minh và check-in",
  "loading": {
    "retrievingLocation": "Đang lấy vị trí...",
    "retrievingWarehouse": "Đang lấy dữ liệu kho hàng..."
  },
  "validation": {
    "fieldRequired": "Trường này là bắt buộc",
    "fieldRequiredWithLabel": "{label} là bắt buộc",
    "phoneInvalid": "Đây không phải là số điện thoại hợp lệ",
    "phoneInvalidWithExample": "Đây không phải là số điện thoại hợp lệ (ví dụ: {example})"
  }
}
